// Imports
import React from "react"
import { BrandLogo, User, BrandLogoDark } from "@icons"
import { useNavbarData } from "@queries"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { Link } from "gatsby"

export const Header = ({ light = false }) => {
  const { navbarLinks } = useNavbarData()

  return (
    <header className={`nav ${light ? "light-mode" : ""}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">{light ? <BrandLogoDark /> : <BrandLogo />}</Link>
        </div>
        <div className="nav-elements">
          <ul>
            {navbarLinks.map((link, index) => {
              return (
                <li key={index}>
                  {index === navbarLinks.length - 1 ? (
                    <a href="https://account.envimap.hu/">
                      <div className="nav-elements-icon">
                        <User color="white" />
                      </div>
                      <span className="nav-elements-profile">{link.text}</span>
                    </a>
                  ) : (
                    <AnchorLink to={link.to} title={link.text} />
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </header>
  )
}
